export default "__VITE_ASSET__54d2618a__"